export enum DashboardOwnerType {
  User = 1,
  Role = 2,
  Group = 3, // group is not supported by BE logic yet
  UserCategory = 4,
}
